import { onError } from '@apollo/client/link/error';
import { pAt, pNetworkError, pNetworkErrorLabel, pOperation } from '../pretty';

export const prettyErrorLink = onError((response) => {
    const { operation, graphQLErrors, networkError } = response;

    if (graphQLErrors) {
        graphQLErrors.forEach((err) => {
            console.pretty.error`${pOperation(operation)} ${
                err.message
            } ${pAt} ${err.locations} ${err.path}`();
        });
    }

    if (networkError) {
        console.pretty.error`${pOperation(
            operation
        )}${pNetworkErrorLabel} while sending an Apollo-request: ${pNetworkError(
            networkError
        )}`();
    }
});
